import { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'primereact/tooltip';

interface TruncatedTextWithTooltipProps {
  text: string;
  className: string;
  style: React.CSSProperties;
  children: React.ReactNode;
  dashboardId: string;
}

// Component that only shows tooltip when text is truncated
export const TruncatedTextWithTooltip = ({
  text,
  className,
  style,
  children,
  dashboardId,
}: TruncatedTextWithTooltipProps) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        const element = textRef.current;
        // Check if the element has ellipsis (text-overflow: ellipsis)
        const computedStyle = window.getComputedStyle(element);
        const hasEllipsis =
          computedStyle.textOverflow === 'ellipsis' &&
          element.scrollWidth > element.clientWidth;
        setIsTruncated(hasEllipsis);
      }
    };

    // Check after a short delay to ensure styles are applied
    const timeoutId = setTimeout(checkTruncation, 200);

    return () => clearTimeout(timeoutId);
  }, [text, dashboardId]);

  return (
    <>
      <Tooltip
        target={textRef}
        content={text}
        position="top"
        showDelay={100}
        hideDelay={100}
        disabled={!isTruncated}
        pt={{
          root: {
            style: {
              zIndex: 9999,
            },
          },
        }}
      />
      <span ref={textRef} className={className} style={style} title={text}>
        {children}
      </span>
    </>
  );
};
